import { useQuery } from '@tanstack/react-query';

import { withError } from '@/react-tools/react-query';
import { EnvironmentId } from '@/react/portainer/environments/types';
import axios, { parseAxiosError } from '@/portainer/services/axios/axios';

import { CustomResourceDefinition } from '../types';

import { queryKeys } from './query-keys';

export function useCustomResourceDefinitions(
  environmentId: EnvironmentId,
  options?: {
    refetchInterval?: number;
    select?: (data: CustomResourceDefinition[]) => CustomResourceDefinition[];
  }
) {
  return useQuery(
    queryKeys.customResourceDefinitions(environmentId),
    () => getCustomResourceDefinitions(environmentId),
    {
      enabled: !!environmentId,
      refetchInterval: options?.refetchInterval,
      select: options?.select,
      ...withError('Unable to retrieve custom resource definitions'),
    }
  );
}

async function getCustomResourceDefinitions(
  environmentId: EnvironmentId
): Promise<CustomResourceDefinition[]> {
  try {
    const { data } = await axios.get<CustomResourceDefinition[]>(
      `/kubernetes/${environmentId}/customresourcedefinitions`
    );
    return data;
  } catch (err) {
    throw parseAxiosError(
      err,
      'Unable to retrieve custom resource definitions'
    );
  }
}
